import React, { useEffect } from 'react'
import './index.scss'

class Dialog extends React.Component {
  constructor(props) {
    super(props)
  }

  setTab(name, label) {
    this.setState({ selectedTab: name, headerValue: '' })
  }

  newMakeTab(properties, tabWidth) {
    const { selectedTab } = this.state,
      { tab, label, active, inactive, iconName, borderCOlor, onShapeChange, key, onTabValue } = properties
    const iconPath = iconName ? require(`../../../../../asset/mapToolsIcons/${iconName}`) : '';

    let onselectShape = (value) => {
      onShapeChange(value)
    }
    let onStateChange = () => {
      onTabValue && onTabValue(label)
    }
    return (
      <div className='tools-items-tab-style'>
        {borderCOlor != null ?
          <>
            <div className='icon-border-style'
              style={{ border: `2px solid ${borderCOlor ? borderCOlor : '#FF6800'}` }}
              onClick={() => {
                if (selectedTab !== tab) {
                  this.setTab(tab, label)
                  if (tab === 'drawObjects') {
                    onselectShape(key)
                  }
                  onStateChange && onStateChange()
                }
              }}
              key={`tab-${tab}`}
            >
              <img className='icon-style'
                src={iconPath} // to get th image to show in webpack build  for normal react-scripts iconPath is enough
              ></img>
            </div>
            <div className='toolbar-navigation-label'>
              {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
            </div>
          </>
          :
          < >
            <img className='icon-style-without-border'
              src={iconPath}
              onClick={() => {
                if (selectedTab !== tab) {
                  this.setTab(tab, label)
                  if (tab === 'drawObjects') {
                    onselectShape(key)
                  }
                  onStateChange && onStateChange()
                }
              }}
              key={`tab-${tab}`}
            ></img>
            <div className='toolbar-navigation-label'>
              {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
            </div>
          </ >
        }
      </div>
    )
  }

  makeTab(properties, tabWidth) {
    const { selectedTab } = this.state,
      { tab, label, active, inactive } = properties
    return (
      <div className={`left-expanded-tab-${selectedTab === tab ? 'active' : 'inactive'}`}
        style={{ width: tabWidth }}
        onClick={() => {
          if (selectedTab !== tab) {
            this.setTab(tab)
          }
        }}
        key={`tab-${tab}`}
      >
        <img className='left-expanded-tab-img'
          src={selectedTab === tab ? active : inactive}
        ></img>
        <div className={`left-expanded-tab-label-${selectedTab === tab ? 'active' : 'inactive'}`}>
          {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
        </div>
      </div>
    )
  }

  makeLayersTab(properties, tabWidth) {
    const { selectedTab } = this.state,
      { tab, label, active, inactive } = properties
    return (
      <div className={`map-layer-tab-${selectedTab === tab ? 'active' : 'inactive'}`}
        style={{ width: tabWidth }}
        onClick={() => {
          if (selectedTab !== tab) {
            this.setTab(tab)
          }
        }}
        key={`tab-${tab}`}
      >
        <div className={`map-layer-tab-label-${selectedTab === tab ? 'active' : 'inactive'}`}>
          {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
        </div>
      </div>
    )
  }

  render() {
    console.error('Must override dialog render function: left-toolbar')
    return (
      null
    )
  }
}

export default Dialog